import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import PropTypes from 'prop-types';
import {
  Route, Redirect,
} from 'react-router-dom';
import { Template } from './components/template/Template';
import api from './services/api';

function PrivateRouteAccess ({ children, ...rest }) {
  const [auth, setAuth] = React.useState('loading');

  React.useEffect(() => {
    (async function () {
      try {
        const { location } = rest;
        const res = await api.post('/permissions', { route: location.pathname });
        setAuth(res.data ? 'loggedin' : 'redirect');
      } catch (err) {
        setAuth('loading');
      }
    }());
  });
  if (auth === 'loading') {
    return (
      <Template>
        <div className="loader" />
      </Template>
    );
  }
  return (
    <Route
      {...rest}
      render={({ location }) => ((auth === 'loggedin') ? (
        children
      )
        : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        ))}
    />
  );
}
PrivateRouteAccess.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRouteAccess;
